import { getLowestPricedVariant } from 'productTemplate/utils/getLowestPricedVariant';
import { IBuyBarProductVariant } from 'shared/types/BuyBarProductVariant';

export const getLowestPricedVariantIndex = (itemList: IBuyBarProductVariant[]) => {
  if (!itemList || itemList.length === 0) {
    return false;
  }

  const {
    lowestPriceCents: { amount: lowestPrice },
  } = getLowestPricedVariant(itemList);

  const lowestPriceIndex = itemList.findIndex(
    (variant) => variant?.lowestPriceCents?.amount === lowestPrice,
  );

  return lowestPriceIndex;
};
